//警告信息
export function promptData (message, that) {
  that.$message({
    showClose: true,
    duration: 2000,
    message: message,
    type: 'warning'
  })
}

//成功的消息
export function successPromptData (message, that) {
  that.$message({
    showClose: true,
    message: message,
    duration: 2000,
    type: 'success'
  })
}

//失败的提示信息(保存数据时,不正确的数据弹出框进行提示)
export function errorPromptData (message, that) {
  that.$alert(message, '提示', {
    confirmButtonText: '确定',
  })
}

export function getTableHeaderStyle (rowIndex) {
  if (rowIndex === 0) {
    return 'background:#989fa8;color: #fff'
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/util/MessageTools.js